export const TILE_SIZE = 50;

export const MAP_DIMENSIONS = {
  COLS: 13,
  ROWS: 12,
  TILE_SIZE,
};

export const MAP_TILE_IMAGES = {
  1: '/public/assets/floor.png',
  2: '/public/assets/map/floor_sand_rock_1.png',
  3: '/public/assets/map/floor_sand_stone_5.png',
  4: '/public/assets/wall.png',
  5: '/public/assets/desk50.png',
  6: '/public/assets/professor.png',
  7: '/public/assets/b1.png',
  8: '/public/assets/c1.png',
  9: '/public/assets/d1.png',
};

export const LAYERS = [
  [
    [3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3],
    [3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 3],
    [3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 3],
    [3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 3],
    [3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 3],
    [3, 1, 1, 5, 1, 1, 5, 1, 1, 5, 1, 1, 3],
    [3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 3],
    [3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 3],
    [3, 1, 1, 5, 1, 1, 5, 1, 1, 5, 1, 1, 3],
    [3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 3],
    [3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 3],
    [3, 3, 3, 1, 1, 1, 3, 3, 3, 3, 3, 1, 3],
  ],
  [
    [4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4],
    [4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4],
    [4, 0, 0, 0, 0, 0, 6, 0, 0, 0, 0, 0, 4],
    [4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4],
    [4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4],
    [4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4],
    [4, 0, 0, 7, 0, 0, 0, 0, 0, 0, 0, 0, 4],
    [4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4],
    [4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4],
    [4, 0, 0, 8, 0, 0, 9, 0, 0, 0, 0, 0, 4],
    [4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4],
    [4, 4, 4, 0, 0, 4, 4, 4, 4, 4, 4, 4, 4],
  ],
];

export const MOVE_DIRECTIONS = {
  w: [0, -1],
  a: [-1, 0],
  s: [0, 1],
  d: [1, 0],
};

export const SOLID_TILES = [4, 5, 6, 7, 8, 9];
